// components/NoData.js
//import Link from "next/link";
import SVG from "react-inlinesvg";
import textLanguage from "@/constants/textLanguage";
const NoData = ({ message = "No Data Found" }) => {
  return (
    <div className="flex flex-col items-center justify-center h-64">
      <div className="text-center">
        <p
          className="text-lg text-gray-600"
          dangerouslySetInnerHTML={{ __html: message }}
        ></p>
      </div>
      <a
        className="flex justify-center items-center h-10 w-auto my-4 border rounded-md border-gray-300 text-gray-500 hover:text-primary hover:bg-gray-100 p-2"
        href="/"
      >
        <div className="flex justify-center items-center">
          {textLanguage?.headerStaticMenuText?.home}
          <SVG
            className="ml-2 h-4 w-4 m-[-2px]"
            src="/assets/icons/svg/menuHome.svg"
          />
        </div>
      </a>
    </div>
  );
};

export default NoData;
